<template>
  <v-combobox
    :loading="isLoading"
    :items="items"
    :search-input.sync="search"
    flat
    label="Product Type"
    clearable
    item-text="name"
    item-value="id"
    v-model="model"
    :disabled="disabled"
    :rules="rules"
    :multiple="multiple"
  >
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-title>
          Search for a
          <strong>Product Type</strong>
        </v-list-item-title>
      </v-list-item>
    </template>
  </v-combobox>
</template>

<script>
export default {
  data() {
    return {
      mandatoryRules: [v => !!v || "This fiels is mandatory"],
      message: null,
      search: null,
      isLoading: false,
      items: []
    };
  },
  props: {
    value: {
      type:[String, Array],
      default: () => null
    },
    disabled: {
      type:Boolean,
      default: () => false
    },
    shopId: {
      type: Number,
      default: () => null
    },
    rules: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    model: {
      get () {
         return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    }
  },
  watch: {
    model() {
      this.$emit("input", this.model);
    }
  },
  mounted: function() {
    this.getFittingType();
  },
  methods: {
    getFittingType() {
      this.$store
        .dispatch("products/getProductTypes", {
          shopId: this.shopId
        })
        .then(data => {
          this.items = data.types;
        });
    }
  }
};
</script>
